import { render, staticRenderFns } from "./SocialInput.vue?vue&type=template&id=90180dfa&"
import script from "./SocialInput.vue?vue&type=script&lang=js&"
export * from "./SocialInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports